import React from 'react';

const TopBar = ({ setSidebarOpen, navigation, activeView }) => {
  return (
    <div className="sticky top-0 z-30 bg-white shadow-sm">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            {/* Mobile menu button - integrated into the top bar */}
            <button
              type="button"
              className="mr-4 md:hidden h-10 w-10 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 transition-colors duration-200"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            
            <h1 className="text-2xl font-semibold text-gray-900">
              {navigation.find(item => item.view === activeView)?.name || 'Dashboard'}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
